import InsightsSidebar from './Sidebar';

export default InsightsSidebar;
